"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M15.607 0a2.531 2.531 0 0 1 2.556 2.397l.005.165v18.796a2.438 2.438 0 0 1-.658 1.827c-.443.47-1.056.76-1.707.808l-.197.007H8.389a2.532 2.532 0 0 1-2.556-2.397l-.005-.165V2.563A2.532 2.532 0 0 1 8.224.005L8.388 0h7.219Zm0 .999h-7.22c-.827 0-1.485.612-1.556 1.418l-.006.145v18.877c0 .826.612 1.485 1.418 1.556l.144.006h7.219c.447 0 .876-.183 1.174-.5.175-.186.373-.492.391-.937l-.002-.174-.001-18.828c0-.828-.612-1.486-1.418-1.557L15.607 1Zm-4.4 18.182a.5.5 0 0 1 .637-.057l.07.057.123.123.122-.123a.5.5 0 0 1 .765.637l-.058.07-.476.476a.503.503 0 0 1-.646.051l-.06-.05-.477-.477a.5.5 0 0 1 0-.707Zm-2.246-3.223a.5.5 0 0 1 .81.576l-.052.074-.174.203.149.15a.5.5 0 0 1-.628.77l-.079-.064-.476-.476a.5.5 0 0 1-.082-.6l.056-.078.476-.555Zm5.34-.028a.5.5 0 0 1 .638-.058l.069.058.555.555a.501.501 0 0 1 .03.673l-.059.06-.554.476a.501.501 0 0 1-.714-.695l.063-.064.146-.125-.174-.174a.5.5 0 0 1 0-.706Zm-2.712.46a.634.634 0 1 1 .897.896.634.634 0 0 1-.897-.896Zm.447-3.303a.5.5 0 0 1 .294.095l.06.05.476.478a.498.498 0 0 1-.628.77l-.079-.064-.123-.123-.122.123a.5.5 0 0 1-.764-.638l.057-.069.477-.476a.498.498 0 0 1 .353-.146Zm-2.51-2.646a.634.634 0 1 1 .897.897.634.634 0 0 1-.897-.897Zm2.063 0a.634.634 0 1 1 .897.896.634.634 0 0 1-.897-.896Zm2.062 0a.634.634 0 1 1 .897.896.634.634 0 0 1-.897-.896Zm-2.062-3.173a.634.634 0 1 1 .897.897.634.634 0 0 1-.897-.897Zm2.062 0a.634.634 0 1 1 .897.897.634.634 0 0 1-.897-.897Zm-4.125 0a.634.634 0 1 1 .897.897.634.634 0 0 1-.897-.897Zm0-3.252a.634.634 0 1 1 .897.897.634.634 0 0 1-.897-.897Zm2.063 0a.634.634 0 1 1 .897.898.634.634 0 0 1-.897-.897Zm2.062 0a.634.634 0 1 1 .897.898.634.634 0 0 1-.897-.897Z",
    clipRule: "evenodd"
  })]
});